<template>
    <v-card tile class="pa-0" hover height="100%">
        <v-card-text class="text-center">
            <p v-if="pieOptions.labels.includes('Promoters') || pieOptions.labels.includes('المنتقدون')" class="responsive-p">{{this.series[0]-this.series[2]}}</p>
            <apexchart ref="apex" :height="height" type="donut" :options="pieOptions" :series="pieOptions.series" />
            <div class="chart-legend">
                <div v-for="(label, i) in labels" :key="i" class="chart-legend-item">
                    <span class="chart-legend-color" :style="{ backgroundColor: colors[i % colors.length] }"></span>
                    <span class="chart-legend-label">{{ label }}</span>
                </div>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
    import apexchart from 'vue-apexcharts'
    import { captureWithLegend, COLORS } from './chartExportUtils'

    export default {

        components: {
            apexchart
        },

        props: ['title', 'height', 'series', 'labels'],

        data() {
            return {
                colors: COLORS,
                pieOptions: {
                    series: this.series,
                    colors: COLORS,
                    labels: this.labels,
                    title: {
                        text: ''
                    },
                    chart: {
                        type: 'donut',
                        fontFamily: 'Tajawal',
                        toolbar: {
                            show: false,
                        }
                    },
                    xaxis: {
                        axisBorder: {
                            show: false
                        },
                        axisTicks: {
                            show: false
                        }
                    },
                    plotOptions: {
                        pie: {
                            donut: {
                                size: '50%'
                            }
                        }
                    },
                    dataLabels: {
                        enabled: true,
                        formatter: function (val, opts) {
                            const percentage = val.toFixed(0) + '%'
                            const number = opts.w.config.series[opts.seriesIndex]
                            return [percentage, number]
                        },
                        style: {
                            fontSize: '9px',
                            fontWeight: ''
                        },
                        offsetX: 0,
                        horizontal: true
                    },
                    responsive: [{
                        breakpoint: 300,
                        options: {
                            chart: {},
                            legend: {
                                show: false
                            }
                        }
                    }],
                    legend: {
                        show: false
                    }
                },
                pieSeries: [],
            }
        },
        watch: {
            series: {
                handler(newSeries) {
                    this.$set(this.pieOptions, 'series', newSeries)
                },
                immediate: true
            },
            labels: {
                handler(newLabels) {
                    this.pieOptions = {
                        ...this.pieOptions,
                        labels: newLabels
                    }
                },
                immediate: true
            }
        },

        methods: {
            async capture() {
                try {
                    return await captureWithLegend(this.$refs.apex, this.labels || [])
                } catch (e) {
                    console.error('Doghnut capture failed', e)
                    return null
                }
            }
        }
    }
</script>

<style>
    .apexcharts-toolbar {
        top: -17px !important;
        right: -20px !important;
    }

    .responsive-p {
        position: absolute;
        font-size: 25px;
        color: red;
        font-weight: bold;
        top: calc(50% - 18px);
        right: calc(50% - 14px);
    }

    .chart-legend {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 8px 16px;
        margin-top: 8px;
        padding: 0 8px 4px;
    }

    .chart-legend-item {
        display: flex;
        align-items: center;
        gap: 5px;
        font-family: 'Tajawal', sans-serif;
        font-size: 12px;
        color: #263238;
    }

    .chart-legend-color {
        display: inline-block;
        width: 12px;
        height: 12px;
        border-radius: 2px;
        flex-shrink: 0;
    }

    .chart-legend-label {
        white-space: nowrap;
    }

    @media screen and (max-width: 768px) {
        .responsive-p {
            font-size: 18px;
            top: calc(50% - 40px);
            right: calc(50% - 10px);
        }
    }

    @media screen and (min-width: 768px) and (max-width: 1044px) {
        .responsive-p {
            font-size: 20px;
            top: calc(50% - 37px);
            right: calc(50% - 11px);
        }
    }
</style>
